import { useCallback } from "react";

import { useMutation, UseMutationResult } from "@tanstack/react-query";

import axios from "@/configs/axios";

interface SummarizeResult {
  data: any;
  status: number;
}

export const usePostSummarize = (): UseMutationResult<
  SummarizeResult,
  Error,
  { blob_name: string },
  unknown
> => {
  const callSummarize = useCallback(
    async (request: { blob_name: string }): Promise<SummarizeResult> => {
      try {
        const url = `${process.env.REACT_APP_SERVER_HOST}/summarize`;
        const response = await axios.post(url, request);
        return response;
      } catch {
        return { status: 500, data: [] };
      }
    },
    []
  );

  return useMutation<SummarizeResult, Error, { blob_name: string }, unknown>({
    mutationFn: callSummarize,
  });
};
